<div class="wrapper-list-menu">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Menus" | translate }}</div>
        </div>
      </div>
      <div class="col text-right">
        <div class="d-inline-block topbar-actions">
          <button
            class="btn btn-primary"
            (click)="showCreateModal(menuDialogRef)"
          >
            {{ "Add menu item" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="checkout-toolbar mb-4">
    <div class="filter-options">
      <!-- Country Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="filteredCountry && filteredCountry !== 'VIEW_ALL'"
          id="dropdownCountry"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-globe mr-1"></i>
          <span>{{ getCountryName(filteredCountry) | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownCountry" class="custom-dropdown shadow-md" style="min-width: 220px; max-height: 320px; overflow-y: auto;">
          <button
            ngbDropdownItem
            *ngFor="let c of countries"
            (click)="changeCountry(c.country_code)"
            class="py-2"
          >
            <div class="d-flex align-items-center">
              <img
                *ngIf="c.country_code && c.country_code !== 'VIEW_ALL' && c.country_code !== 'ALL'"
                [src]="getFlagImageURL(c.country_code)"
                class="mr-2 flex-shrink-0"
                style="width: 20px; height: 14px; object-fit: cover; border-radius: 2px;"
              />
              <i *ngIf="!c.country_code || c.country_code === 'VIEW_ALL' || c.country_code === 'ALL'" class="fi fi-rr-globe mr-2 text-muted" style="font-size: 14px;"></i>
              <span class="text-truncate">{{ c.country_name | translate }}</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Language Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="language_code && language_code !== 'VIEW_ALL'"
          id="dropdownLanguage"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-world mr-1"></i>
          <span>{{ getLanguageName(language_code) | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownLanguage" class="custom-dropdown shadow-md" style="min-width: 180px;">
          <button
            ngbDropdownItem
            *ngFor="let l of language"
            (click)="changeLanguage(l.language_code, l.language_name)"
            class="py-2"
          >
            <span>{{ l.language_name | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search Input Box -->
    <div class="search-box">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filteredString"
        (input)="updateFilter($event)"
        placeholder="{{ 'Filter by menu title' | translate }}..."
      />
      <i class="fi fi-rr-search search-icon"></i>
      <i class="fas fa-times clear-icon" *ngIf="filteredString" (click)="clearMenuSearch()"></i>
    </div>
  </div>

  <div class="section-action">
    <ng-template #menuDialogRef let-modal>
      <div class="modal-body modal-menu">
        <div class="loading-spinner col-12 mt-5 pb-3" *ngIf="modalLoading">
          <mat-spinner class="mx-auto" [diameter]="50"></mat-spinner>
        </div>
        <div class="row order-card my-2" *ngIf="!modalLoading">
          <div class="col-lg-12 col-sm-12">
            <div class="text-left">
              <p class="title-text font-weight-bold mb-2">
                <span *ngIf="modalType === 'CREATE'">{{
                  "Add Menu Item" | translate
                }}</span>
                <span *ngIf="modalType === 'EDIT'">{{
                  "Edit Menu Item" | translate
                }}</span>
              </p>
            </div>
            <form [formGroup]="menuForm" autocomplete="off">
              <p class="value-text font-weight-bold mt-4 required">
                {{ "Name" | translate }}
              </p>
              <input
                class="input-field mt-2"
                type="text"
                name="menu-name"
                id="menu-name"
                formControlName="menu_name"
              />
              <div *ngIf="+menuType === 2">
                <p class="value-text font-weight-bold mt-3 required">
                  {{ "Link" | translate }}
                </p>
                <div
                  ngbDropdown
                  class="d-inline-block w-100 mt-2"
                  *ngIf="externalDisplay"
                >
                  <input
                    class="input-field-dropdown mt-2 w-100"
                    type="text"
                    name="menu-link"
                    id="menu-link"
                    formControlName="menu_link"
                    placeholder="{{ 'Search or paste a link' | translate }}"
                    (click)="inputTouch()"
                    ngbDropdownToggle
                  />
                  <i
                    class="fi fi-rr-link-alt mr-2 absolute left-3 top-5"
                    *ngIf="urlType"
                  ></i>
                  <i
                    class="fi fi-rr-file mr-2 absolute left-3 top-5"
                    *ngIf="!urlType"
                  ></i>
                  <div
                    class="btn remove-button"
                    (click)="removeUrl()"
                    *ngIf="menuForm.value?.menu_link !== ''"
                  >
                    <i class="fi fi-rr-cross-small"></i>
                  </div>
                  <div
                    ngbDropdownMenu
                    aria-labelledby="dropdownBasic2"
                    class="custom-dropdown"
                  >
                    <button
                      ngbDropdownItem
                      *ngFor="let url of filterPageList"
                      (click)="changeExternalLink(url.page_title, url.page_url)"
                      class="text-ellipsis overflow-hidden text-slate-800"
                    >
                      <i class="fi fi-rr-file mr-2 align-middle"></i
                      ><b>{{ url.page_title }}</b>
                    </button>
                  </div>
                </div>
                <div
                  ngbDropdown
                  class="d-inline-block w-100 mt-2"
                  *ngIf="!externalDisplay"
                >
                  <input
                    class="input-field-dropdown mt-2 w-11/12"
                    type="text"
                    name="menu-link"
                    id="menu-link"
                    formControlName="menu_link"
                    placeholder="Search or paste a link"
                  />
                  <i
                    class="fi fi-rr-link-alt mr-2 absolute left-3 top-5"
                    *ngIf="urlType"
                  ></i>
                  <i
                    class="fi fi-rr-file mr-2 absolute left-3 top-5"
                    *ngIf="!urlType"
                  ></i>
                  <div
                    class="absolute align-middle rounded-md mt-2 ml-2 text-xl bg-white justify-center items-center h-10 drop-shadow-xs border-red-200 !border text-red-600 group-hover:border-red-300 hover:!border-red-200 !border text-red-600 hover:!bg-red-50/[0.5] group hover:no-underline group px-2 d-inline-flex cursor-pointer"
                    (click)="removeUrl()"
                  >
                    <i class="fi fi-rr-cross-small h-5"></i>
                  </div>
                  <div
                    ngbDropdownMenu
                    aria-labelledby="dropdownBasic2"
                    class="custom-dropdown"
                  >
                    <button
                      ngbDropdownItem
                      *ngFor="let url of filterPageList"
                      (click)="changeExternalLink(url.page_title, url.page_url)"
                      class="text-ellipsis overflow-hidden text-slate-800"
                    >
                      <i class="fi fi-rr-file mr-2 align-middle"></i
                      ><b>{{ url.page_title }}</b>
                    </button>
                  </div>
                </div>
              </div>
              <div class="md:col-span-5 mt-2 d-flex" *ngIf="+menuType === 2">
                <div class="w-50">
                  <p class="value-text font-weight-bold mt-3 required">
                    {{ "Country" | translate }}
                  </p>
                  <div ngbDropdown class="d-inline-block w-100 pr-4 mt-2">
                    <button
                      class="btn btn-outline-primary btn-dropdown w-100"
                      id="dropdownBasic2"
                      ngbDropdownToggle
                    >
                      <div
                        class="btn-image-container"
                        *ngIf="
                          ![null, '', 'ALL'].includes(
                            menuForm.value?.menu_country?.toUpperCase().trim()
                          )
                        "
                      >
                        <img
                          [src]="getFlagImageURL(menuForm.value?.menu_country)"
                        />
                      </div>
                      <div class="dropdown-name-inner">
                        {{
                          getCountryName(menuForm.value?.menu_country)
                            | translate
                        }}
                      </div>
                    </button>

                    <div
                      ngbDropdownMenu
                      aria-labelledby="dropdownBasic2"
                      class="custom-dropdown"
                    >
                      <ng-container *ngFor="let c of countries">
                        <button
                          ngbDropdownItem
                          (click)="createFormChangeCountry(c.country_code)"
                          *ngIf="c.country_code?.toLowerCase() !== 'view_all'"
                        >
                          {{
                            coalesce(c.create_form_name, c.country_name)
                              | translate
                          }}
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="w-50">
                  <p class="value-text font-weight-bold mt-3 required">
                    {{ "Language" | translate }}
                  </p>

                  <div ngbDropdown class="d-inline-block w-100 mt-2">
                    <button
                      class="btn btn-outline-primary btn-dropdown w-100"
                      id="dropdownBasic2"
                      ngbDropdownToggle
                    >
                      <div class="dropdown-name-inner">
                        {{
                          getLanguageName(menuForm.value?.menu_language)
                            | translate
                        }}
                        <span
                          class="secondary"
                          *ngIf="
                            ![null, '', 'ALL'].includes(
                              menuForm.value?.menu_language
                                ?.toUpperCase()
                                .trim()
                            )
                          "
                          >({{ menuForm.value?.menu_language }})</span
                        >
                      </div>
                    </button>
                    <div
                      ngbDropdownMenu
                      aria-labelledby="dropdownBasic2"
                      class="custom-dropdown"
                    >
                      <ng-container *ngFor="let l of language">
                        <button
                          ngbDropdownItem
                          (click)="
                            createFormChangeLanguage(
                              l.language_code,
                              l.language_name
                            )
                          "
                          *ngIf="l.language_code?.toLowerCase() !== 'view_all'"
                        >
                          {{
                            coalesce(l.create_form_name, l.language_name)
                              | translate
                          }}
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md:col-span-5 mt-2">
                <div class="mb-2">
                  <span for="menu-visibility" class="font-medium">{{
                    "Visible" | translate
                  }}</span>
                  <label
                    class="flex justify-between align-items-center switch-container"
                  >
                    <span>{{ "Show and hide this menu." | translate }}</span>
                    <div class="section-switch">
                      <label class="switch">
                        <input
                          type="checkbox"
                          [checked]="+visibility === 1"
                          [disabled]="radioDisable"
                          (change)="
                            +visibility === 1
                              ? (visibility = 0)
                              : (visibility = 1)
                          "
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </label>
                </div>
              </div>
              <p class="value-text font-weight-bold mt-3">
                {{ "Description" | translate }}
              </p>
              <textarea
                id="menu-description"
                class="textarea-field mt-2"
                type="text"
                name="menu-description"
                formControlName="menu_desc"
              ></textarea>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer modal-menu" *ngIf="!modalLoading">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="modal.dismiss('Cross click')"
        >
          {{ "Cancel" | translate }}
        </button>
        <button
          *ngIf="modalType === 'CREATE'"
          type="button"
          class="btn btn-primary"
          (click)="menuCreate()"
        >
          {{ "Add" | translate }}
        </button>
        <button
          *ngIf="modalType === 'EDIT'"
          type="button"
          class="btn btn-primary"
          (click)="menuUpdate(storeMenuId)"
        >
          {{ "Update" | translate }}
        </button>
      </div>
    </ng-template>
  </div>

  <div
    class="fixed bottom w-[86.8%] md:w-[80%] z-50 bottom-0 pointer-events-none"
    [class]="isTileView ? '' : ''"
  >
    <div
      class="md:w-1/2 sm:w-[80%] w-full mt-10 bg-indigo-500 text-white p-2 shadow-md mx-auto transition ease-in-out duration-400 rounded flex place-content-between pointer-events-auto"
      [class]="
        isArrangementModified
          ? '-translate-y-1/2 opacity-100'
          : 'translate-y-full opacity-0'
      "
    >
      <span class="align-self-center ml-2">{{
        isArrangementModified
          ? "Menu arrangement has been modified! Save now?"
          : "Not Modified"
      }}</span>
      <div class="button-container">
        <button
          class="bg-white/[0] text-white px-4 py-2 rounded hover:!bg-white/[0.1] transition duration-300 ease-in-out border-white border"
          [class]="
            isSavingArrangement
              ? 'pointer-events-none !bg-white/[.2]'
              : 'pointer-events-auto'
          "
          (click)="resetMenuArrangement()"
        >
          {{ "Reset" | translate }}
        </button>
        <button
          class="bg-white text-indigo-600 px-4 py-2 rounded hover:!bg-indigo-100 transition duration-300 ease-in-out border"
          [class]="
            isSavingArrangement
              ? 'pointer-events-none !bg-white/[.6]'
              : 'pointer-events-auto'
          "
          (click)="saveMenuArrangement()"
        >
          {{ "Save" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="section-main">
    <div
      class="col-lg-12 col-sm-12"
      *ngIf="
        (menuList?.length === 0 || getDisplayedMenu()?.length === 0) && !loading
      "
    >
      <div class="card">
        <div>
          <div class="p-10 text-center no-records">
            {{ "No Record found" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="menu-list"
      [class]="{
        'listing-mode-tile': isListView,
        'listing-mode-list': isTileView
      }"
    >
      <div *ngIf="loading">
        <div class="loading-spinner col-12 mt-5">
          <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
        </div>
      </div>
      <div *ngIf="!loading" cdkDropListGroup>
        <div
          class="flex flex-wrap ease-in-out duration-300 py-1"
          [class]="isTileView ? 'divide-y divide-slate-200/50 ' : ''"
          [class.is-loading]="isSavingArrangement"
        >
          <div
            *ngFor="let item of getDisplayedMenu()"
            cdkDropList
            [cdkDropListEnterPredicate]="dropListEnterPredicate"
            class="select-none menu-item-tile duration-1000 transition ease-in-out"
            [class]="
              isListView
                ? 'w-full group -mb-3'
                : 'xl:w-[20%] lg:w-[25%] md:w-[33.3%] w-[50%]'
            "
          >
            <div
              cdkDrag
              (cdkDragMoved)="dragMoved($event)"
              (cdkDragStarted)="dragStarted($event)"
              (cdkDragDropped)="dragDropped($event)"
              [cdkDragData]="item"
              class="drag-box"
            >
              <div
                class="flex relative transition bg-white duration-300 ease-in-out shadow-sm hover:!shadow-lg group"
                [class]="
                  isListView
                    ? 'flex-row p-3 border !border-gray-200 hover:!bg-slate-50 dark:hover:!bg-slate-800 group-first:!rounded-t-md group-last:!rounded-b-md'
                    : 'flex-column border !border-transparent rounded hover:!border-indigo-200'
                "
              >
                <div
                  class="flex justify-between w-full align-items-center"
                  [class]="isListView ? 'px-1 py-1 ' : 'px-3 py-3 !pt-2'"
                >
                  <div class="text-start truncate align-items-center flex mr-4">
                    <div
                      class="text-sm font-medium text-start flex items-center w-6 h-6 justify-center cursor-grab"
                    >
                      <svg
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 0H1C0.45 0 0 0.45 0 1C0 1.55 0.45 2 1 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0ZM1 6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6Z"
                          fill="#747E8B"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="text-start truncate align-items-center flex">
                    <div
                      class="capitalize text-sm font-medium text-start truncate"
                    >
                      {{ item.menu_name }}
                    </div>
                  </div>

                  <div class="ml-auto mr-20">
                    <div
                      class="text-sm justify-right items-center text-gray-600 pr-3 opacity-75"
                      #tooltip="matTooltip"
                      [matTooltip]="
                        +item.visibility === 1
                          ? 'Currently shown'
                          : 'Currently hidden'
                      "
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                    >
                      <i
                        class="align-middle"
                        [class]="
                          +item.visibility === 1
                            ? 'fi fi-rr-eye '
                            : 'fi fi-rr-eye-crossed text-red-600'
                        "
                      ></i>
                    </div>
                  </div>

                  <div
                    class="actions self-center flex gap-1"
                    [class]="
                      isListView ? 'lg:w-2/5  lg:place-content-between' : ''
                    "
                  >
                    <div class="text-center">
                      <div>
                        <p
                          class=""
                          #tooltip="matTooltip"
                          matTooltip="Created on {{
                            item.created_at | date : 'medium'
                          }}"
                          matTooltipPosition="above"
                          matTooltipHideDelay="100"
                          class="text-sm font-semibold"
                          *ngIf="item?.created_at"
                        >
                          {{ item?.created_at | timeago : true }}
                        </p>
                        <p
                          *ngIf="
                            item.updated_at !== item.created_at &&
                            item?.updated_at
                          "
                          #tooltip="matTooltip"
                          matTooltip="Edited on {{
                            item.updated_at | date : 'medium'
                          }}"
                          matTooltipPosition="above"
                          matTooltipHideDelay="100"
                          class="text-slate-400 text-xs mt-1 font-medium"
                        >
                          {{ "Edited" | translate }}
                          {{ item?.updated_at | timeago : true }}
                        </p>
                      </div>
                    </div>

                    <div class="text-center flex justify-end self-center">
                      <button
                        type="button"
                        class="btn-styles rounded ml-2 bg-white justify-center items-center h-7 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-indigo-300 hover:!border-indigo-200 !border text-indigo-600 hover:!bg-indigo-50/[0.5] group hover:no-underline"
                        (click)="showEditModal(menuDialogRef, item)"
                      >
                        <i class="fi fi-rr-edit"></i
                        ><span>{{ "Edit" | translate }}</span>
                      </button>
                      <button
                        type="button"
                        class="btn-styles rounded ml-2 bg-white justify-center items-center h-7 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-red-300 hover:!border-red-200 !border text-red-600 hover:!bg-red-50/[0.5] group hover:no-underline"
                        (click)="deleteMenu(content, item)"
                        *ngIf="item?.type == 2"
                      >
                        <i class="fi fi-rr-trash"></i
                        ><span>{{ "Delete" | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #content let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
              {{ "Delete Menu" | translate }}
            </h4>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="modal.dismiss('Cross click')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-secondary">
              {{
                "Are you sure you want to proceed with the deletion?"
                  | translate
              }}
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              (click)="modal.close('Save click')"
            >
              {{ "Cancel" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-red"
              (click)="modal.close('delete')"
            >
              {{ "Proceed to Delete" | translate }}
            </button>
          </div>
        </ng-template>

        <ng-template #success let-modal>
          <div class="modal-body text-center">
            <div class="row" align="center">
              <div class="col pt-4 pt-lg-0">
                <h4>{{ "Successfully Update" | translate }}</h4>
              </div>
            </div>
            <button
              class="btn btn-primary"
              type="button"
              name="button"
              (click)="modal.close('Send click')"
            >
              {{ "Close" | translate }}
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
